import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { ReleaseResourceRequestDialog } from '~/modules/resourcing/common/components';
import { useMeContext } from '~/modules/me/useMeContext';
import { useReleaseResourceAllocationHandler } from './hooks';

import useQuickAllocationContext from './hooks/useQuickAllocationContext';

export const QuickAllocationReleaseResourceRequestDialog = ({
  showReleaseResourcesDialog,
  closeReleaseResourcesDialog,
  selectedAllocation
}) => {
  const { setAvailabilityLoading } = useQuickAllocationContext();

  const me = useMeContext();

  const req = useMemo(
    () =>
      selectedAllocation.resourceAllocation.project && {
        role: selectedAllocation.resourceAllocation.role,
        resourceAllocations: [
          {
            ...selectedAllocation.resourceAllocation,
            user: {
              ...selectedAllocation.resourceUser,
              user: selectedAllocation.resourceUser
            }
          }
        ],
        startDate: selectedAllocation.resourceAllocation.startDate,
        endDate: selectedAllocation.resourceAllocation.endDate,
        projectUri: selectedAllocation.resourceAllocation.project.id
      },
    [selectedAllocation.resourceAllocation, selectedAllocation.resourceUser]
  );

  const { releaseResourceAllocation } = useReleaseResourceAllocationHandler({
    resourceAllocation: selectedAllocation.resourceAllocation,
    allocationSort: selectedAllocation.allocationSort,
    me,
    scale: selectedAllocation.scale
  });

  const releaseAllocation = useCallback(
    val => {
      setAvailabilityLoading();

      releaseResourceAllocation(val);
    },
    [releaseResourceAllocation, setAvailabilityLoading]
  );

  return (
    <ReleaseResourceRequestDialog
      resourceRequest={req}
      onReleaseResourceAllocationsForRequest={releaseAllocation}
      open={showReleaseResourcesDialog}
      onCancelClick={closeReleaseResourcesDialog}
      canEditTask={(
        selectedAllocation.resourceAllocation?.project?.permittedActionUris ||
        []
      ).includes('urn:replicon:project-action:edit-tasks')}
    />
  );
};

export default QuickAllocationReleaseResourceRequestDialog;

QuickAllocationReleaseResourceRequestDialog.propTypes = {
  closeReleaseResourcesDialog: PropTypes.func.isRequired,
  showReleaseResourcesDialog: PropTypes.bool.isRequired,
  selectedAllocation: PropTypes.object.isRequired
};
